/*@flow*/
import ApolloClient from 'apollo-client';
import getToken from 'lib/getToken';
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';

import introspectionQueryResultData from './fragmentTypes.json';
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

// Netork cache
const cache = new InMemoryCache({
  dataIdFromObject: (o) => o.id,
  fragmentMatcher,
});

// Links
const httpLink = createHttpLink({ uri: '/graphql' });

const middlewareLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': getToken() },
  });
  return forward(operation);
});

export const link: any = middlewareLink.concat(httpLink);

// Client
const client: any = new ApolloClient<*>({
  link,
  uri: '/graphql',
  cache,
});

export default client;
